define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.indexOf;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/indexOf.js
// module id = 28
// module chunks = 0